import HeroCarousel from "./components/HeroCarousel";
import QuickCategories from "./components/QuickCategories";
import NewsSection from "./components/NewsSection";
import HotMovies from "./components/HotMovies";
import SpecialsSection from "./components/SpecialsSection";
import SiteIntro from "./components/SiteIntro";
import usePageMeta from "@/hooks/usePageMeta";

export default function Home() {
  usePageMeta({
    title: "555电影 - 最新电影资讯与热门片单推荐",
    description:
      "555电影提供最新电影资讯、热门电影推荐和详细片单，覆盖多类型影片，满足影迷多样观影需求，助您轻松查找心仪电影。",
    keywords: "555电影,最新电影,电影资讯,热门电影,电影片单,电影推荐,观影指南",
  });

  return (
    <div className="w-full animate-fadeIn">
      <HeroCarousel />
      <QuickCategories />
      <NewsSection />
      <HotMovies />
      <SpecialsSection />
      <SiteIntro />
    </div>
  );
}